<<template>
<div ref="basePanel">    
    <param-panel :config="config" :rs="rs" /><pager-panel :crowCount="config.rowCount" :cpageNo="config.pageNo" :cpageSize="config.pageSize"
    @CFHandler="CFHandler" :selIdx="selIdx" :rightList="config.rights">
      <li v-if='rights("ChangeStatus")' v-show="typeof this.selIdx == 'number'" class="nav-system"><a @click.stop="changeStatus">{{getChangeRS()}}</a></li>
    </pager-panel><list-panel :config="config" :isAutoLoad='1' :rs="rs" @updateIdx="updateIdx" :selIdx="selIdx" />

</div>
</template>


<script>
import data from "./data";
import mixin from "@/fui/mixin";

export default {
  data() {
    return {
      config: data
    };
  },
  methods: {
    getChangeRS() {
      const obj = this.getSelRow()
      if (obj) {
        return obj.status == 1 ? this.rs["disable"] : this.rs["enable"];
      }
      return "";
    },
    changeStatus() {
      const obj = this.getSelRow();
      if (obj) {
        const s = obj.status == 1 ? 0 : 1;
        if (s == 0 && !this.$confirm("是否确认禁用" + obj.empName + "的账户？"))
          return;
        if (s == 1 && !this.$confirm("是否确认启用" + obj.empName + "的账户？"))
          return;
        this.$getData(
          this.config.url +
            "ChangeStatus?status=" +
            s +
            "&id=" +
            obj.autoid +
            this.$urlSq(),
          data => {
            if (data.rs == 1) {
              obj.status = s;
            }
          }
        );
      }
    }
  },
  components: {
    "detail-panel": () => import("./detail")
  },
  mixins: [mixin.list]
};
</script>
